import { Action } from '@ngrx/store';
import { IBalance } from 'src/app/models/balance.interface';

export enum EBalanceActions {
  GetBalance = '[Balance] Get Balance',
  GetBalanceSuccess = '[Balance] Get Balance Success',
  GetBalanceReset = '[Balance] Get Balance Reset'
}

export class GetBalance implements Action {
  public readonly type = EBalanceActions.GetBalance;
  constructor(public payload: string) {}
}

export class GetBalanceSuccess implements Action {
  public readonly type = EBalanceActions.GetBalanceSuccess;
  constructor(public payload: IBalance) {}
}

export class GetBalanceReset implements Action {
  public readonly type = EBalanceActions.GetBalanceReset;
  constructor() {}
}

export type BalanceActions =
  | GetBalance
  | GetBalanceSuccess
  | GetBalanceReset;

